import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReviewReq, ReviewRes } from './../../types/reviewType';
import { api } from "../../config/Api";
import { stat } from "fs";
import { ApiResponse } from "../../types/apiResponse";



const BASE_URL = "/api/review"
export const createReview = createAsyncThunk<ReviewRes, { req: ReviewReq, orderId: number, productId: number }, { rejectValue: string }>(
  "reviews/createReview",
  async ({ req, orderId, productId }, { rejectWithValue }) => {
    try {
      // null is in the middle represent for empty body
      const response = await api.post(`${BASE_URL}/${orderId}/${productId}/reviews`, req
      )
    
      return response.data
    } catch (error: any) {
    
      rejectWithValue(error.response.data.message || "FAILED TO APPLY COUPON")
    }
  })
// get review by productId 

export const fetchReviewsByProductId = createAsyncThunk<ReviewRes[], number , { rejectValue: string }>(
  "reviews/fetchReviewsByProductId",
  async (productId , { rejectWithValue }) => {
    try {
      // null is in the middle represent for empty body
      const response = await api.get(`${BASE_URL}/products/${productId}/reviews`)
      return response.data
    } catch (error: any) {
    
      rejectWithValue(error.response.data.message || "FAILED TO APPLY COUPON")
    }
  })
  // get review by reviewId Product and User

  export const fetchReviewByProductAndUser = createAsyncThunk<ReviewRes, number, { rejectValue: string }>(
    "reviews/fetchReviewByProductAndUser",
    async (productId , { rejectWithValue }) => {
      try {
        // null is in the middle represent for empty body
        const response = await api.get(`${BASE_URL}/${productId}/reviews`)
        return response.data
      } catch (error: any) {
      
        rejectWithValue(error.response.data.message || "FAILED TO APPLY COUPON")
      }
    })

  // update Review
  export const updateReview = createAsyncThunk<ReviewRes, {req:ReviewReq,reviewId:number} , { rejectValue: string }>(
    "reviews/updateReview",
    async ({req,reviewId} , { rejectWithValue }) => {
      try {
        // null is in the middle represent for empty body
        const response = await api.patch(`${BASE_URL}/${reviewId}`,req)
        return response.data
      } catch (error: any) {
        
        rejectWithValue(error.response.data.message || "FAILED TO APPLY COUPON")
      }
    })
  
// delete Review

export const deleteReview = createAsyncThunk<ApiResponse<string>, number , { rejectValue: string }>(
  "reviews/deleteReview",
  async (reviewId, { rejectWithValue }) => {
    try {
      // null is in the middle represent for empty body
      const response = await api.delete(`${BASE_URL}/${reviewId}`)
      return response.data
    } catch (error: any) {
      
      rejectWithValue(error.response.data.message || "FAILED TO APPLY COUPON")
    }
  })


interface ReviewState {
  review: ReviewRes | null;
  reviews: ReviewRes[];
  isDeleted: boolean;
  loading: boolean;
  error: string | null | undefined;
  
}
const initialState: ReviewState = {
  review: null,
  reviews: [],
  isDeleted: false,
  loading: false,
  error: null
}
export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createReview.pending, (state) => {
        state.loading = true
      })
      .addCase(createReview.fulfilled, (state, action: PayloadAction<ReviewRes>) => {
        state.loading = false;
        state.review = action.payload
      })
      .addCase(createReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message
      })
        // get review by reviewId Product and User

        .addCase(fetchReviewByProductAndUser.pending, (state) => {
          state.loading = true
        })
        .addCase(fetchReviewByProductAndUser.fulfilled, (state, action: PayloadAction<ReviewRes>) => {
          state.loading = false;
          state.review = action.payload
        })
        .addCase(fetchReviewByProductAndUser.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message
        })

      // getReview by productId

      .addCase(fetchReviewsByProductId.pending, (state) => {
        state.loading = true
        state.isDeleted=false
      })
      .addCase(fetchReviewsByProductId.fulfilled, (state, action: PayloadAction<ReviewRes[]>) => {
        state.loading = false;
        state.reviews = action.payload
      })
      .addCase(fetchReviewsByProductId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message
      })

      // get Review By  product and user
      .addCase(updateReview.pending, (state) => {
        state.loading = true
      })
      .addCase(updateReview.fulfilled, (state, action: PayloadAction<ReviewRes>) => {
        state.loading = false;
      const index =  state.reviews.findIndex((item) =>  item.id ==action.payload.id )
        if(index!==-1){
          state.reviews[index]= action.payload
        }
      })
      .addCase(updateReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message
      })

      // delete Review
      //  ! (non-null assertion operator)
      .addCase(deleteReview.pending, (state) => {
        state.loading = true
      })
      .addCase(deleteReview.fulfilled, (state) => {
        state.loading = false;
       state.isDeleted=true
        
      })
      .addCase(deleteReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message
      })

  }
})


export const reviewSliceReducer = reviewSlice.reducer